import type { DocumentFeature } from '../../core';
import { RotationTransform } from './components/RotationTransform';
import { getTargetRotationDimensions } from './helpers';
import { createRotationSlice } from './slice';
import type { RotationDeps, RotationSlice } from './types';

type RotationFeature = DocumentFeature<RotationDeps, RotationSlice>;

export const createRotationFeature = (): RotationFeature => ({
  id: 'rotation',
  slice: createRotationSlice,
  transformContribution: {
    getEffectiveDimensions: getTargetRotationDimensions,
    Wrapper: RotationTransform,
    order: 10,
  },
});
